export function FolderDefault({ ...props }) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fill="currentColor"
        d="M5 2.5C3.61929 2.5 2.5 3.61929 2.5 5V15C2.5 16.3807 3.61929 17.5 5 17.5H15C16.3807 17.5 17.5 16.3807 17.5 15V8.33333C17.5 6.95262 16.3807 5.83333 15 5.83333H11.25L9.5 3.5C9.02786 2.87049 8.28689 2.5 7.5 2.5H5ZM9.16667 5.83333H4.16667V5C4.16667 4.53976 4.53976 4.16667 5 4.16667H7.5C7.7623 4.16667 8.00929 4.29016 8.16667 4.5L9.16667 5.83333ZM4.16667 15V7.5H15C15.4602 7.5 15.8333 7.8731 15.8333 8.33333V15C15.8333 15.4602 15.4602 15.8333 15 15.8333H5C4.53976 15.8333 4.16667 15.4602 4.16667 15Z"
      />
    </svg>
  );
}
